export const SET_REFUSE_MODAL = 'SET_REFUSE_MODAL';
export const SET_MODAL_IMAGE = 'SET_MODAL_IMAGE';
